import { View, styled, useTheme } from 'tamagui'
import type { GetProps } from 'tamagui'

const GlowBoxBase = styled(View, {
  variants: {
    glow: {
      accent: {},
      voice: {},
      error: {},
      hover: {},
      none: {},
    },
  } as const,
})

type GlowBoxProps = GetProps<typeof GlowBoxBase>

export function GlowBox({ glow, style, ...props }: GlowBoxProps) {
  const theme = useTheme()

  const glowShadows: Record<string, string> = {
    accent: theme.shadowGlow?.val || 'none',
    voice: theme.shadowGlowVoice?.val || 'none',
    error: theme.error?.val ? `0 0 12px ${theme.error.val}33` : 'none',
    hover: theme.shadowCardHover?.val || 'none',
  }

  const shadow = glow ? glowShadows[glow as string] || 'none' : 'none'

  return (
    <GlowBoxBase
      glow={glow}
      {...props}
      // @ts-expect-error -- web box-shadow
      style={{ ...((typeof style === 'object' && style) || {}), boxShadow: shadow }}
    />
  )
}
